import { useTranslation } from "react-i18next";
import './index.less'
import { getSymbol } from "@/config/symbol";
import { formatNumber } from "@/utils";
import { getDexs } from "@/config/swap";
import { isSuiCoinType } from "@/utils/suiMethods";

const { stableCoins } = getDexs()

export default function AccountOverview({ accountOverview, selectedAccountOverview, tokenA, otherTokenInfo, tokenAInfo, tokenBInfo }: any) {
  const { t } = useTranslation();
  const FUSDC_ADDRESS = stableCoins[0].address;
  const BNB_ADDRESS = t("batchTransfer.nativeToken", { symbol: getSymbol() });

  return (
    <div className="account-overview">
      <h4>{t("batchSwap.accountOverview")}</h4>
      <div className="info">
        <p className="addrs-count">{t("batchSwap.totalAddrsCount", { count: accountOverview?.addressCount || "-" })}</p>
        <div className="row">
          <div className="col">
            <span>{t("batchSwap.nativeBalance", { symbol: getSymbol() })}</span>
            <span>{accountOverview?.balance}</span>
          </div>
          {!isSuiCoinType(tokenAInfo.coinType) && <div className="col">
            {/* tokenA */}
            <span>{t("batchSwap.tokenBalance", { symbol: tokenAInfo.symbol })}</span>
            <span>{accountOverview?.tokenABalance}</span>
          </div>}
          {!isSuiCoinType(tokenBInfo.coinType) && <div className="col">
            {/* tokenB */}
            <span>{t("batchSwap.tokenBalance", { symbol: tokenBInfo.symbol })}</span>
            {
              <p>{formatNumber(accountOverview?.selectedTokenBBalance, 4) || "-"}</p>
            }
          </div>}
        </div>
      </div>
      <div className="line"></div>
      <div className="info">
        <p className="addrs-count">{t("batchSwap.selectedAddrsCount", { count: selectedAccountOverview?.addressCount || "-" })}</p>
        <div className="row">
          <div className="col">
            <span>{t("batchSwap.nativeBalance", { symbol: getSymbol() })}</span>
            <span>{selectedAccountOverview?.balance}</span>
          </div>
          {!isSuiCoinType(tokenAInfo.coinType) && <div className="col">
            <span>{t("batchSwap.tokenBalance", { symbol: tokenAInfo.symbol })}</span>
            <span>{selectedAccountOverview?.tokenABalance}</span>
          </div>}
          {!isSuiCoinType(tokenBInfo.coinType) && <div className="col">
            <span>{t("batchSwap.tokenBalance", { symbol: tokenBInfo.symbol })}</span>
            {
              <p>{formatNumber(selectedAccountOverview?.selectedTokenBBalance, 4) || "-"}</p>
            }
          </div>}
        </div>
      </div>
    </div>
  )
}